






/** @format */

import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import EchartOption from '@/common/const/e-chart-options';

@Component({
  components: {}
})
export default class RevenueDataLine extends Vue {
  options: EchartOption = new EchartOption();
  isData: boolean = true;

  yAxisData: string[] = [];
  seriesBarData: number[] = [];
  @Prop()
  chartData!: any; //图表数据
  get title() {
    return {
      show: false
    };
  }

  get toolTip() {
    return {};
  }

  get grid() {
    return {
      top: '10',
      left: '10',
      right: '4%',
      bottom: '5',
      containLabel: true
    };
  }

  get legend() {
    return {
      show: false
    };
  }

  get xAxis() {
    return {
      type: 'category',
      boundaryGap: false,
      data: this.chartData.revenuexAxisData,
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      splitLine: {
        show: false,
        lineStyle: {
          color: '#fff',
          opacity: '0.1'
        }
      },
      axisLabel: {
        color: '#43549A'
      }
    };
  }

  get yAxis() {
    return {
      type: 'value',
      axisLine: {
        show: false
        // lineStyle: {
        //   color: '#604CDD',
        // },
      },
      splitLine: {
        lineStyle: {
          color: '#fff',
          opacity: '0.1'
        }
      },
      axisLabel: {
        color: '#43549A'
      }
    };
  }

  get series() {
    return [
      {
        name: '临停营收',
        type: 'line',
        stack: '总量',
        smooth: true,
        animation: true,
        animationEasing: 'linear',
        animationDuration: 5000,
        animationDurationUpdate: 1000,
        data: this.chartData.revenueSeriesData,
        itemStyle: {
          normal: {
            borderColor: '#f6cf37' //拐点边框颜色
          }
        },
        symbol: 'circle'
      }
    ];
  }

  async fetchChartData() {
    // try {
    //   const { data } = await api.queryAbnormalStatistics(param)
    //   // todo 临时屏蔽
    //   let data2 = data.filter(i => i.name != '跟车出场' && i.name != '被冲出场')
    //   this.seriesBarData = data2.map(i => i.num)
    //   this.yAxisData = data2.map(i => i.name)
    // } catch (e) {
    //   console.log(e)
    // } finally {
    //   this.refreshChart()
    // }
  }

  refreshChart() {
    const options: EchartOption = new EchartOption();
    options.setLegend(this.legend);
    options.setGrid(this.grid);
    options.setXAxis(this.xAxis, true);
    options.setYAxis(this.yAxis, true);
    options.setTitle(this.title);
    options.setSeries(this.series);
    options.setTooltip(this.toolTip);
    options.setColor(['#f6cf37']);
    this.options = options;
  }

  init() {
    // this.fetchChartData()
  }

  mounted() {
    //this.refreshChart()
    // this.init()
  }
}
